<template>
  <div>
    <div class="header py-7 py-lg-8 pt-lg-9"></div>
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <!-- Error Alert -->
          <b-alert variant="danger" dismissible v-if="error">{{ error }}</b-alert>

          <b-card no-body class="bg-transparent border border-light">
            <b-card-header>
              <h1 class="text-center mt-2 mb-3 text-dark pt-3">Welcome</h1>
              <p class="text-center text-dark">Please sign in with<br />your credentials</p>
              <div class="text-center text-dark">
                <small>For support please contact us at <a href="mailto:support@infrafon.com">support@infrafon.com</a></small>
              </div>
            </b-card-header>

            <b-card-body class="bg-secondary rounded-bottom">
              <b-form @submit.prevent="onSubmit" class="mx-3">
                <b-form-group class="mb-3">
                  <b-input-group>
                    <b-input-group-prepend>
                      <span class="input-group-text"><i class="ni ni-hat-3"></i></span>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="model.username"
                      placeholder="Username"
                      required
                      autofocus
                    />
                  </b-input-group>
                </b-form-group>

                <b-form-group class="mb-3">
                  <b-input-group>
                    <b-input-group-prepend>
                      <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="model.password"
                      type="password"
                      placeholder="Password"
                      required
                    />
                  </b-input-group>
                </b-form-group>

                <div class="text-center">
                  <b-button type="submit" variant="dark" class="my-3" :disabled="general.isLoading">
                    <b-spinner small v-if="general.isLoading" class="mr-2"></b-spinner>
                    <span class="px-3">Sign in</span>
                  </b-button>
                </div>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { Action } from "@/store/actions"

export default {
  name: "Login",
  data() {
    return {
      model: {
        username: "",
        password: ""
      }
    }
  },
  computed: {
    ...mapState({
      general: state => state.general,
      error: state => state.auth.authError,
      rights: state => state.auth.rights
    })
  },
  methods: {
    onSubmit() {
      // Prevent double submit
      if (this.general.isLoading) return
      this.$store
        .dispatch(Action.auth.login, { name: this.model.username, password: this.model.password })
        .then(() => {
          this.$router.push({ name: "dashboard" })
        })
        .catch(error => console.error(error))
      this.model.password = ""
    }
  }
}
</script>